import styled from 'styled-components'

const CreateBlogDialogErrorMessageUi = styled.span`
  font-size: 16px;
  color: red;
  margin-right: 5px;
`

export default CreateBlogDialogErrorMessageUi
